// Calcolo locale di alba e tramonto ("sunrise equation", stessa matematica di
// SunCalc). Evita di bloccare il caricamento della dashboard su un'API esterna
// (api.sunrisesunset.io). Precisione ~1 minuto: piu' che sufficiente per
// distinguere giorno / notte nelle card.

const RAD = Math.PI / 180;
const DAY_MS = 1000 * 60 * 60 * 24;
const J1970 = 2440588;
const J2000 = 2451545;
const OBLIQUITY = RAD * 23.4397;
const PERIHELION = RAD * 102.9372;
// Altezza del centro del sole all'alba / tramonto (bordo + rifrazione atmosferica).
const H0 = RAD * -0.833;

const toJulian = (date) => date.valueOf() / DAY_MS - 0.5 + J1970;
const fromJulian = (j) => new Date((j + 0.5 - J1970) * DAY_MS);
const toDays = (date) => toJulian(date) - J2000;

const solarMeanAnomaly = (d) => RAD * (357.5291 + 0.98560028 * d);

const eclipticLongitude = (m) => {
    const center = RAD * (1.9148 * Math.sin(m) + 0.02 * Math.sin(2 * m) + 0.0003 * Math.sin(3 * m));
    return m + center + PERIHELION + Math.PI;
};

const declination = (l) => Math.asin(Math.sin(l) * Math.sin(OBLIQUITY));

const approxTransit = (ht, lw, n) => 0.0009 + (ht + lw) / (2 * Math.PI) + n;
const solarTransitJ = (ds, m, l) => J2000 + ds + 0.0053 * Math.sin(m) - 0.0069 * Math.sin(2 * l);

const hourAngle = (h, phi, dec) =>
    Math.acos((Math.sin(h) - Math.sin(phi) * Math.sin(dec)) / (Math.cos(phi) * Math.cos(dec)));

export const computeSunTimes = (date, lat, lng) => {
    const lw = RAD * -lng;
    const phi = RAD * lat;
    const d = toDays(date);

    const n = Math.round(d - 0.0009 - lw / (2 * Math.PI));
    const ds = approxTransit(0, lw, n);
    const m = solarMeanAnomaly(ds);
    const l = eclipticLongitude(m);
    const dec = declination(l);

    const jNoon = solarTransitJ(ds, m, l);

    const cosH = (Math.sin(H0) - Math.sin(phi) * Math.sin(dec)) / (Math.cos(phi) * Math.cos(dec));
    // Sole sempre sopra / sotto l'orizzonte: non capita alle latitudini di
    // Ancona, ma evitiamo comunque di restituire Invalid Date.
    if (cosH >= 1) return { sunrise: fromJulian(jNoon), sunset: fromJulian(jNoon) };
    if (cosH <= -1) return { sunrise: fromJulian(jNoon - 0.5), sunset: fromJulian(jNoon + 0.5) };

    const w = hourAngle(H0, phi, dec);
    const jSet = solarTransitJ(approxTransit(w, lw, n), m, l);
    const jRise = jNoon - (jSet - jNoon);

    return { sunrise: fromJulian(jRise), sunset: fromJulian(jSet) };
};
